import _implicitStylesheets from "./chip.css";
import _implicitScopedStylesheets from "./chip.scoped.css?scoped=true";
import _axIconInteractive from "ax/iconInteractive";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  classMap: {
    "chip-close": true
  },
  props: {
    "iconDescription": "Close",
    "icon": "close"
  },
  key: 1
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, t: api_text, c: api_custom_element, h: api_element} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.classes),
    key: 0
  }, [api_text(api_dynamic_text($cmp.text)), api_custom_element("ax-icon-interactive", _axIconInteractive, stc0)])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5tg5rqetce2";
tmpl.legacyStylesheetToken = "undefined-_chip";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
